export const mobileData = {
    watchmarttMobile: '918200351478',
    watchOnTimeMobile: '919428505487',
    watchHeavenMobile: '918140064730',
    watchRoyalMobile: '919825100214'
}